const paths = new Set(['/help','/dashboard','/salesChannel','/orders','/products','/categories','/catalogs','/attributes','/clients','/discounts','/configuration','/asistente']);
export const adminReturnPath = value => {
 if(typeof value!=='string')return '/dashboard';
 const [pathname,hash]=value.split('#');
 if(!paths.has(pathname))return '/dashboard';
 return pathname+(pathname==='/configuration' && /^\d{3}$/.test(hash || '')?`#${hash}`:'');
};
